import { useSuspenseInfiniteQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { bulletinBoardSchema } from '../../../common/validations'
import { get } from '../apiClient'

import { toSupportedLanguage } from 'i18n/i18n'

interface UseAPIGetBulletinBoardBulletinsProps {
  contractId: string
}

export const useAPIGetBulletinBoardBulletins = ({
  contractId,
}: UseAPIGetBulletinBoardBulletinsProps) => {
  const { i18n } = useTranslation()
  const lang = toSupportedLanguage(i18n.resolvedLanguage)

  const { data, fetchNextPage, hasNextPage } = useSuspenseInfiniteQuery({
    queryKey: ['bulletinBoard', contractId, lang],
    queryFn: async ({ pageParam }) => {
      const searchParams = new URLSearchParams({
        page: String(pageParam),
        language: lang,
      })
      const response = await get(
        `/contracts/${contractId}/bulletins?${searchParams.toString()}`,
        bulletinBoardSchema
      )
      return response || { bulletins: [], nextPage: null }
    },
    getNextPageParam: (lastPage) => {
      return lastPage.nextPage || undefined
    },
    initialPageParam: 0,
  })

  const bulletins = data?.pages.flatMap((page) => page.bulletins) ?? []

  return {
    bulletins,
    fetchNextPage,
    hasNextPage: !!hasNextPage,
  }
}
